import {companyFeaturesConstants} from '../../constants';
import {useCompanyFeatureAvailable} from './useCompanyFeatureAvailable';

const featureName = companyFeaturesConstants.SDI_ENABLED;

/**
 * Checks whether this company's cassetto fiscale is already delegated — i.e. a business registry
 * configuration exists for it on A-cube, so supplier invoices arrive over SDI.
 *
 * ⚠ Reads `false` for a company with no flag row at all, which is deliberate: an unbackfilled
 * company is treated as "not connected" and is shown the prompt, rather than being silently
 * skipped. That is the safe direction for an upsell and the wrong one for anything gating access.
 *
 * @returns {boolean} True when the `sdi_enabled` company feature is on.
 *
 * @example
 * const isSdiEnabled = useIsSdiEnabled();
 */
export const useIsSdiEnabled = () => {
  return useCompanyFeatureAvailable(featureName);
};
